'use client';

import { useEffect } from 'react'
import { MantineProvider, createTheme } from '@mantine/core';
import NavigationBar from "./Navbar";
import { ModalsProvider } from "@mantine/modals";
import Footer from "./Footer";
import { useAtom } from 'jotai'
import * as atoms from '@/config/store/globalStore'
import { COOKIE_ITEMS, getCookieItem } from '@/utils/cookieControl'
import { API_ENDPOINT } from '@/config/endpoint/endpoint'
import dynamic from 'next/dynamic';
import AOS from 'aos'
import 'aos/dist/aos.css';
import mixpanel from 'mixpanel-browser';
import MobileMenu from './MobileMenu';
import Maintanance from '@/components/Maintanance';
import { getLocalStorageItem, setLocalStorageItem } from '@/utils/localStorageControl';

const Toaster = dynamic(() =>
  import('react-hot-toast').then((toaster) => toaster.Toaster)
);

const theme = createTheme({
  defaultRadius: "0.5rem",
});

mixpanel.init('124f0686fc83c497f94548abbffafc64', {
  debug: true, 
  track_pageview: true,
  persistence: 'localStorage'
});


export default function DefaultLayout({ children }: { children: React.ReactNode }) {
  const [isDarkMode, setIsDarkMode] = useAtom(atoms.isDarkModeAtom);

  useEffect(() => {
    AOS.init({ once: true });
    
    // Check for stored theme preference
    const storedTheme = getLocalStorageItem('theme');
    if (storedTheme === 'dark') {
      setIsDarkMode(true);
      document.documentElement.classList.add('dark');
    } else if (storedTheme === 'light') {
      setIsDarkMode(false);
      document.documentElement.classList.remove('dark');
    } else {
      // If no stored preference, use system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setIsDarkMode(prefersDark);
      if (prefersDark) {
        document.documentElement.classList.add('dark');
        setLocalStorageItem('theme', 'dark');
      } else {
        document.documentElement.classList.remove('dark');
        setLocalStorageItem('theme', 'light');
      }
    }
  }, []);

  // Update the class and localStorage when isDarkMode changes
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      setLocalStorageItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      setLocalStorageItem('theme', 'light');
    }
  }, [isDarkMode]);

  const languageCheck = () => {
    const lang = getLocalStorageItem('lang');
    if (lang) {

    }
  }


  // 에러페이지
  // return (
//     <MantineProvider theme={theme}>
//       <ModalsProvider>
//         <Maintanance/>
//       </ModalsProvider>
//     </MantineProvider>
  // )


  return ( 
    <>
      <Toaster
        toastOptions={{ duration: 2000 }}
        containerStyle={{ fontSize: 14 }}
      />
      <NavigationBar/>
      {children}
      <Footer/>
      {/* <MobileMenu/> */}
    </>
  );
}